import { render } from "./ModalNoX.vue?vue&type=template&id=efaf2ede&scoped=true"
import script from "./ModalNoX.vue?vue&type=script&lang=js"
export * from "./ModalNoX.vue?vue&type=script&lang=js"

import "./ModalNoX.vue?vue&type=style&index=0&id=efaf2ede&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaf2ede"]])

export default __exports__